import { useFormState } from '@vtex/admin-ui-form'
import { useCallback, useEffect } from 'react'
import { DefaultValues, FieldValues } from 'react-hook-form'
const { vestResolver } = require('@hookform/resolvers/vest')

type Props<T> = {
  config: T
  isOpen: boolean
  validationFn?: (values: T) => void
}

export function useDrawerSubForm<T extends FieldValues = FieldValues>(
  props: Props<T>
) {
  const { config, isOpen, validationFn } = props

  const drawerForm = useFormState<T>({
    defaultValues: { ...config } as DefaultValues<T>,
    resolver: validationFn ? vestResolver(validationFn) : undefined,
  })

  const setInitialConfig = useCallback(() => {
    drawerForm.reset({ ...config } as DefaultValues<T>)
  }, [config, drawerForm])

  useEffect(() => {
    if (isOpen) {
      setInitialConfig()
    }
  }, [isOpen, setInitialConfig])

  return { drawerForm }
}
